<template>
  <v-container grid-list-md class="pa-0 ma-0">
    <v-layout row wrap>
      <v-flex xs12 mx-auto>
        <!-- Blocks -->
        <v-card class="ma-2">
          <v-card-title class="pa-2 grey lighten-4">
            <span class="title grey--text">Blocks</span>
            <v-spacer></v-spacer>
            <v-btn class="accent--text ma-0" small flat @click="prepareCreateBlock">Add New</v-btn>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="facSet"
            :items="blockList"
            hide-actions
            >
            <template slot="items" slot-scope="props">
              <tr @click="prepareEditBlock(props.item)">
                <td>{{ props.item.block_nm ? props.item.block_nm : '-' }}</td>
                <td>{{ props.item.floors ? props.item.floors : '-' }}</td>
                <td>{{ props.item.flats ? props.item.flats : '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <!-- Applicable Water Types -->
      <v-card class="ma-2">
        <v-card-title class="pa-2 grey lighten-4">
          <div class="title grey--text">Applicable Water Types</div>
          <v-spacer></v-spacer>
          <v-btn class="accent--text ma-0" small flat @click="prepareCreateWaterType">Add New</v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-data-table
            :headers="watType"
            :items="typeList"
            hide-actions
            >
          <template slot="items" slot-scope="props">
            <tr @click="prepareEditWaterType(props.item)">
              <td>{{ props.item.water_type }}</td>
              <td><v-icon :color="props.item.is_source ? 'green' : 'red'">{{ props.item.is_source ? 'check' : 'close' }}</v-icon></td>
            </tr>
          </template>
          </v-data-table>
        </v-card-text>
      </v-card>

    <!-- Water Quality Parameter -->
    <v-card class="ma-2">
      <v-card-title class="pa-2 grey lighten-4">
        <div class="title grey--text">Water Quality Param</div>
        <v-spacer></v-spacer>
        <v-btn class="accent--text ma-0" small flat @click="prepareCreateWaterQual">Add New</v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-data-table
        class="tblWaterQual"
        :headers="$vuetify.breakpoint.smAndUp?watQual:watQualsm"
        :items="qualList"
        hide-actions
        >
        <template slot="items" slot-scope="props">
          <tr @click="prepareEditWaterQual(props.item)">
            <td @click="dragElement()" class="handle"><v-icon small>zoom_out_map</v-icon></td>
            <td>{{ props.item.water_type ? props.item.water_type : '-' }}</td>
            <td>{{ props.item.param_name ? props.item.param_name : '-' }}</td>
            <td>{{ props.item.uom ? props.item.uom : '-' }}</td>
            <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.std_val_min ? props.item.std_val_min : 0 }}</td>
            <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.std_val_max ? props.item.std_val_max : 0 }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>

  <!-- Water Storage -->
  <v-card class="ma-2">
    <v-card-title class="pa-2 grey lighten-4">
      <div class="title grey--text">Water Storage</div>
      <v-spacer></v-spacer>
      <v-btn class="accent--text ma-0" small flat @click="prepareCreateStorage">Add New</v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="$vuetify.breakpoint.smAndUp?waterStorage:waterStorageSm"
      :items="storageList"
      hide-actions
      >
      <template slot="items" slot-scope="props">
        <tr @click="prepareEditStorage(props.item)">
          <td>{{ props.item.storage_nm ? props.item.storage_nm : '-' }}</td>
          <td>{{ props.item.water_cat }}</td>
          <td>{{ props.item.storage_cap ? props.item.storage_cap : '-' }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">
            <v-icon color="green" v-if="props.item.is_level_checked">check</v-icon>
            <v-icon color="red" v-else>close</v-icon>
          </td>
          <!--<td v-if="$vuetify.breakpoint.smAndUp">
          <v-icon color="green" v-if="props.item.is_receipt_checked">check</v-icon>
          <v-icon color="red" v-else>close</v-icon>
        </td>-->
        <td v-if="$vuetify.breakpoint.smAndUp">
          <v-icon color="green" v-if="props.item.is_cons_checked">check</v-icon>
          <v-icon color="red" v-else>close</v-icon>
        </td>
      </tr>
    </template>
  </v-data-table>
</v-card-text>
</v-card>

<!-- Power Meters -->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Power Meters</div>
    <v-spacer></v-spacer>
    <v-btn class="accent--text ma-0" small flat @click="prepareCreateMeter">Add New</v-btn>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
    :headers="powerMeter"
    :items="meterList.filter(rec => rec.meter_nm !== '')"
    hide-actions
    >
    <template slot="items" slot-scope="props">
      <tr @click="prepareEditMeter(props.item)">
        <td>{{ props.item.meter_nm ? props.item.meter_nm : '-' }}</td>
        <td>{{ props.item.meter_location ? props.item.meter_location : '-' }}</td>
        <td>{{ props.item.area_covered ? props.item.area_covered : '-' }}</td>
      </tr>
    </template>
  </v-data-table>
</v-card-text>
</v-card>

<!-- Gensets -->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Gensets</div>
    <v-spacer></v-spacer>
    <v-btn class="accent--text ma-0" small flat @click="prepareCreateGensets">Add New</v-btn>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
    :headers="$vuetify.breakpoint.smAndUp?genSets:genSetsSm"
    :items="gensetList.filter(rec => rec.genset_nm !== '')"
    hide-actions
    >
    <template slot="items" slot-scope="props">
      <tr @click="prepareEditGensets(props.item)">
        <td>{{ props.item.genset_nm ? props.item.genset_nm : '-' }}</td>
        <td>{{ props.item.genset_rating ? props.item.genset_rating : '-' }}</td>
        <td>{{ props.item.genset_cap }}</td>
      </tr>
    </template>
  </v-data-table>
</v-card-text>
</v-card>

<!-- Sanity Checks -->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Sanity Checks</div>
    <v-spacer></v-spacer>
    <v-btn class="accent--text ma-0" small flat @click="prepareCreateSanCheck">Add New</v-btn>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
    :headers="hygHead"
    :items="sanCheckList"
    hide-actions
    >
    <template slot="items" slot-scope="props">
      <tr @click="prepareEditSanCheck(props.item)">
        <td>{{ props.item.check_cat ? props.item.check_cat : '-' }}</td>
        <td>{{ props.item.check_desc ? props.item.check_desc : '-' }}</td>
      </tr>
    </template>
  </v-data-table>
</v-card-text>
</v-card>

<!-- Other Custom Metrics -->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Other Custom Metrics</div>
    <v-spacer></v-spacer>
    <v-btn class="accent--text ma-0" small flat @click="prepareCreateCusMet">Add New</v-btn>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
    :headers="cusMet"
    :items="metricList"
    hide-actions
    >
    <template slot="items" slot-scope="props">
      <tr @click="prepareEditCusMet(props.item)">
        <td>{{ props.item.metric_cat ? props.item.metric_cat : '-' }}</td>
        <td>{{ props.item.metric_nm ? props.item.metric_nm : '-' }}</td>
        <td>{{ props.item.period_display? props.item.period_display: '-' }}</td>
      </tr>
    </template>
  </v-data-table>
</v-card-text>
</v-card>

<!-- Daily Update Photo Categories-->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Daily Update Photo Categories</div>
    <v-spacer></v-spacer>
    <v-btn class="accent--text ma-0" small flat @click="prepareCreatePhotoCat">Add New</v-btn>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
    :headers="photoCatHeader"
    :items="photoCat"
    hide-actions
    >
    <template slot="items" slot-scope="props">
      <tr @click="prepareEditPhotoCat(props.item)">
        <td>{{ props.item.attach_cat_name }}</td>
      </tr>
    </template>
  </v-data-table>
</v-card-text>
</v-card>

<!-- Security gaurd posts -->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Security Gaurd Posts</div>
    <v-spacer></v-spacer>
    <v-btn class="accent--text ma-0" small flat @click="prepareCreateSecPost">Add New</v-btn>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
    :headers="secPostHeader"
    :items="secPostList"
    hide-actions
    >
    <template slot="items" slot-scope="props">
      <tr @click="prepareEditSecPost(props.item)">
        <td>{{ props.item.security_post }}</td>
      </tr>
    </template>
  </v-data-table>
</v-card-text>
</v-card>

<!-- Daily report for notifications -->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Notifications for Daily Report</div>
  </v-card-title>
  <v-card-text class="pa-2">
    <v-text-field
    v-model="lReport.email_list"
    label="Mail ids"
    hide-details
    maxlength="200"
    placeholder="Notification mail ids(comma seperated)"
    ></v-text-field>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn class="accent" @click="saveDailyReportMailIds(lReport.email_list)">Save</v-btn>
  </v-card-actions>
</v-card>

<!-- Weekly report for notifications -->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Notifications for Weekly Report</div>
  </v-card-title>
  <v-card-text class="pa-2">
    <v-text-field
    v-model="lReport.email_wlist"
    label="Mail ids for weekly report"
    hide-details
    maxlength="200"
    placeholder="Notification mail ids(comma seperated)"
    ></v-text-field>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn class="accent" @click="saveWeeklyReportMailIds(lReport.email_wlist)">Save</v-btn>
  </v-card-actions>
</v-card>

<!-- Other configs -->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Other configurations</div>
  </v-card-title>
  <v-layout >
      <v-flex xs3 class="pa-2" >
        <v-select
          v-model="lReport.att_dev_type"
          :items="['Manual', 'FC Device']"
          label="Attendance device type"
          outlined >
        </v-select>
      </v-flex>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="accent" @click="saveOtherConfigs(lReport.att_dev_type)">Save</v-btn>
      </v-card-actions>
  </v-layout>
</v-card>

<!-- Smartility IoT Devices -->
<v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Smartility IoT Devices</div>
    <v-spacer></v-spacer>
    <v-btn class="accent--text ma-0" small flat @click="prepareCreateSmartDevice">Add New</v-btn>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
    :headers="smartDev"
    :items="deviceList"
    hide-actions
    >
    <template slot="items" slot-scope="props">
      <tr @click="prepareEditSmartDevice(props.item)">
        <td>{{ props.item.smart_dev_type ? props.item.smart_dev_type : '-' }}</td>
        <td>{{ props.item.smart_dev_sno ? props.item.smart_dev_sno : '-' }}</td>
        <td>{{ props.item.smart_dev_loc ? props.item.smart_dev_loc : '-' }}</td>
      </tr>
    </template>
  </v-data-table>
</v-card-text>
</v-card>
<!-- Compliance Category -->
        <v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Compliance Category</div>
    <v-spacer></v-spacer>
    <v-btn class="accent--text ma-0" small flat @click="prepareCreateComplianceCategory">Add New</v-btn>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
      :headers="complianceCategoryHeaders"
      :items="complianceCategoryList"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <tr @click="prepareEditComplianceCategory(props.item)">
          <td>{{ props.item.name }}</td>
        
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
      <!-- Compliance Subcategory -->
       <v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Compliance Subcategory</div>
    <v-spacer></v-spacer>
    <v-btn class="accent--text ma-0" small flat @click="prepareCreateComplianceSubcategory">Add New</v-btn>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
      :headers="complianceSubcatHeaders"
      :items="complianceSubcatList"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <tr @click="prepareEditComplianceSubcategory(props.item)">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.category_name || getCategoryName(props.item.category_id) }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
      <!-- Compliance Type -->
      <v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Compliance Type</div>
    <v-spacer></v-spacer>
    <v-btn class="accent--text ma-0" small flat @click="prepareCreateComplianceType">Add New</v-btn>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
      :headers="complianceTypeHeaders"
      :items="complianceTypeList"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <tr @click="prepareEditComplianceType(props.item)">
          <td>{{ props.item.name }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
       <!-- Compliance -->
        <v-card class="ma-2">
  <v-card-title class="pa-2 grey lighten-4">
    <div class="title grey--text">Compliance</div>
    <v-spacer></v-spacer>
    <v-btn class="accent--text ma-0" small flat @click="prepareCreateCompliance">Add New</v-btn>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
      :headers="complianceHeaders"
      :items="complianceList"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <tr @click="prepareEditCompliance(props.item)">
          <td>{{ props.item.compliance_name || props.item.name }}</td>
          <td>{{ props.item.category_name || getComplianceCategoryName(props.item.category_id) }}</td>
          <td>{{ props.item.subcategory_name || getComplianceSubcategoryName(props.item.subcategory_id) }}</td>
          <td>{{ formatDate(props.item.valid_from) }}</td>
          <td>{{ formatDate(props.item.valid_to) }}</td>
          <td>{{ props.item.cost ? '₹' + props.item.cost.toLocaleString() : '-' }}</td>
          <td class="text-center">
            <v-icon :color="props.item.show_dashboard ? 'green' : 'grey'">
              {{ props.item.show_dashboard ? 'visibility' : 'visibility_off' }}
            </v-icon>
          </td>
          <!-- Validity Status as colored tick -->
          <td class="text-center">
            <v-icon
              v-if="props.item.validity_status === 'Active'"
              color="green"
            >
              check
            </v-icon>

            <v-icon
              v-else-if="props.item.validity_status === 'About to expire'"
              color="amber darken-2"
            >
              warning
            </v-icon>

            <v-icon
              v-else-if="props.item.validity_status === 'Expired'"
              color="red"
            >
              close
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-flex>
</v-layout>

<!--Creating and updating the Blocks-->
<v-dialog v-model="showBlock" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveChanges(lBlock.action)">
        <v-card scrollable>
          <v-card-title class="title grey lighten-4">
            {{ lBlock.action }} Block
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lBlock.block_nm"
                label="Block Name"
                :rules="[rules.required]"
                hide-details
                maxlength="25"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lBlock.floors"
                label="Floors"
                hide-details
                type="number"
                maxlength="11"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lBlock.flats"
                label="Flats"
                hide-details
                type="number"
                maxlength="11"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showBlock = false">Cancel</v-btn>
            <v-btn flat v-if="lBlock.action === 'Update'" @click="deleteBlock(lBlock)">delete</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!--Creating and updating the Water Types-->
<v-dialog v-model="showWaterType" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveWaterTypeChanges(lWaterType.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lWaterType.action }} Water Type
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                v-model="lWaterType.water_type"
                :items="masterTypeList"
                label="Water Type"
                hide-details
                :rules="[rules.required]"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-checkbox v-model="lWaterType.is_source"
                label="Source of water to this community"
                hide-details
                >
              </v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn flat @click.stop="showWaterType = false">Cancel</v-btn>
          <v-btn flat v-if="lWaterType.action === 'Update'" @click="deleteWaterType(lWaterType)">delete</v-btn>
          <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-flex>
</v-container>
</v-dialog>

<!--Creating and updating the Water Quality-->
<v-dialog v-model="showWaterQuality" persistent max-width="500px" >
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveWatQualChanges(lWaterQual.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lWaterQual.action }} Water Quality
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                v-model="lWaterQual.water_type_pair"
                label="Water Type"
                :items="typeList"
                item-text="water_type"
                return-object
                :rules="[rules.required]"
                hide-details
                @input="loadWaterQualityReference(lWaterQual.water_type_pair.water_type_id)"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-combobox
                v-model="lWaterQual.param_name"
                label="Parameter Name"
                :items="paramList.map(rec => rec.param_name)"
                hide-details
                @input="loadBasedParamName(lWaterQual.param_name, lWaterQual.water_type_id)"
                ></v-combobox>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lWaterQual.uom"
                label="UoM"
                hide-details
                maxlength="10"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lWaterQual.std_val_min"
                label="Min"
                hide-details
                type="number"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lWaterQual.std_val_max"
                label="Max"
                hide-details
                type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showWaterQuality = false">Cancel</v-btn>
            <v-btn flat v-if="lWaterQual.action ==='Update'" @click="deleteQual(lWaterQual)">delete</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!--Creating and updating the Water Storage-->
<v-dialog v-model="showWaterStorage" persistent max-width="600px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveStorageChanges(lStorage.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lStorage.action }} Water Storage
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs7 sm6>
                    <v-text-field
                    v-model="lStorage.storage_nm"
                    label="Storage Name"
                    :rules="[rules.required]"
                    hide-details
                    maxlength="25"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs5 sm6>
                    <v-text-field
                    v-model="lStorage.storage_cap"
                    label="Storage Capacity"
                    hide-details
                    type="number"
                    maxlength="11"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select
                v-model="lStorage.water_cat"
                :items="['Domestic', 'Recycled/Treated']"
                label="Category"
                :rules="[rules.required]"
                hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-checkbox v-model="lStorage.is_level_checked"
                    label="Is Level Checked?" hide-details class="mt-2"></v-checkbox>
                  </v-flex>
                  <!-- <v-flex xs12 sm4>
                  <v-checkbox v-model="lStorage.is_receipt_checked"
                  label="Is Receipt Checked?" hide-details class="mt-2"></v-checkbox>
                </v-flex> -->
                <v-flex xs12 sm6>
                  <v-checkbox v-model="lStorage.is_cons_checked"
                  label="Is Consumption Checked?" hide-details class="mt-2"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 class="pt-3 pb-0">
              <span class="primary--text subheader pa-0">Real Time Monitoring</span>
            </v-flex>
            <v-flex xs12 class="pt-0">
              <v-layout row wrap>
                <v-flex xs6>
                  <v-select
                  v-model="lStorage.rtm_provider"
                  :items="['Waltr', 'Waterize']"
                  placeholder="No RTM Installed"
                  clearable
                  hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="lStorage.rtm_integrate_id_1"
                  :label="lStorage.rtm_provider ? lStorage.rtm_provider + ' Tank Id' : ''"
                  :rules="lStorage.rtm_provider ? [rules.required] : []"
                  hide-details
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 class="pt-3 pb-0">
              <span class="primary--text subheader pa-0">Water Level Alert</span>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field
                  v-model="lStorage.min_level"
                  label="Min Water Level (%)"
                  type="number"
                  hide-details
                  :disabled="lStorage.is_level_checked ? false : true"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="lStorage.max_level"
                  label="Max Water Level (%)"
                  type="number"
                  hide-details
                  :disabled="lStorage.is_level_checked ? false : true"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn flat @click.stop="showWaterStorage = false">Cancel</v-btn>
          <v-btn flat v-if="lStorage.action ==='Update'" @click="deleteStorage(lStorage)">delete</v-btn>
          <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-flex>
</v-container>
</v-dialog>

<!--Creating and updating the Power Meter-->
<v-dialog v-model="showPowerMeter" persistent max-width="500px" >
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveMeterChanges(lPowerMeter.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lPowerMeter.action  }} Power Meter
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lPowerMeter.meter_nm"
                label="Meter Name"
                :rules="[rules.required]"
                hide-details
                maxlength="25"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lPowerMeter.meter_location"
                label="Meter Location"
                hide-details
                maxlength="25"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lPowerMeter.area_covered"
                label="Area Covered"
                :rules="[rules.required]"
                hide-details
                maxlength="15"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showPowerMeter = false">Cancel</v-btn>
            <v-btn flat v-if="lPowerMeter.action === 'Update'" @click="deleteMeter(lPowerMeter)">delete</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!--Creating and updating the Genset-->
<v-dialog v-model="showGenset" persistent max-width="500px" >
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveGenChanges(lGen.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lGen.action }} Genset
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lGen.genset_nm"
                label="Genset Name"
                :rules="[rules.required]"
                hide-details
                maxlength="15"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lGen.genset_rating"
                label="Genset Rating"
                hide-details
                maxlength="15"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lGen.genset_cap"
                label="Genset Capacity (ltr)"
                hide-details
                maxlength="15"
                type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showGenset = false">Cancel</v-btn>
            <v-btn flat v-if="lGen.action === 'Update'" @click="deleteGen(lGen)">delete</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!--Creating and updating the Custom Metric-->
<v-dialog v-model="showCustomMetric" persistent max-width="500px" >
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveCustomMetChanges(lCusMet.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lCusMet.action  }} Custom Metric
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-combobox
                v-model="lCusMet.metric_cat"
                label="Metric category"
                :items="metricList.map(rec => rec.metric_cat)"
                :rules="[rules.required]"
                hide-details
                maxlength="25"
                ></v-combobox>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lCusMet.metric_nm"
                label="Metric Name"
                :rules="[rules.required]"
                hide-details
                maxlength="50"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                v-model="lCusMet.period_display"
                label="What to display when this metric is viewed for multiple days"
                :items="[{'value':'A', 'text':'Average'}, {'value':'T', text:'Total'}]"
                item-value="value"
                item-text="text"
                :rules="[rules.required]"
                hide-details
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showCustomMetric= false">Cancel</v-btn>
            <v-btn flat v-if="lCusMet.action === 'Update'" @click="deleteMet(lCusMet)">delete</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!--Creating and updating the Sanity checks-->
<v-dialog v-model="showSanChecks" persistent max-width="500px" >
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="hForm" @submit.prevent="saveSanCheckChanges(lSanCheck.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lSanCheck.action }} Sanity Check
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-combobox
                v-model="lSanCheck.check_cat"
                label="Category"
                :items="sanCheckList.map(rec => rec.check_cat)"
                :rules="[rules.required]"
                hide-details
                maxlength="50"
                ></v-combobox>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                v-model="lSanCheck.check_desc"
                label="Description"
                :rules="[rules.required]"
                hide-details
                maxlength="150"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showSanChecks= false">Cancel</v-btn>
            <v-btn flat v-if="lSanCheck.action === 'Update'" @click="deleteSanCheck(lSanCheck)">delete</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!--Creating and updating the daily update photo categories-->
<v-dialog v-model="showPhotoCat" persistent max-width="500px" >
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="savePhotoCat(lPhotoCat.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lPhotoCat.action }} Photo Category
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lPhotoCat.attach_cat_name"
                label="Category Name"
                :rules="[rules.required]"
                hide-details
                maxlength="100"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showPhotoCat = false">Cancel</v-btn>
            <v-btn flat v-if="lPhotoCat.action === 'Update'" @click="deletePhotoCat(lPhotoCat)">delete</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!--Creating and updating the security posts -->
<v-dialog v-model="showSecPost" persistent max-width="300px" >
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="pForm" @submit.prevent="saveSecPost(lSecPost.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lSecPost.action }} Security Post
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lSecPost.security_post"
                label="Post Name / Gaurd Location"
                :rules="[rules.required]"
                hide-details
                maxlength="10"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showSecPost = false">Cancel</v-btn>
            <v-btn flat v-if="lSecPost.action === 'Update'" @click="deleteSecPost()">delete</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!--Creating and updating the Smartility IoT Devices-->
<v-dialog v-model="showIoTDevices" persistent max-width="500px" >
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="lForm" @submit.prevent="saveSmartDeviceChanges(lSmartDev.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lSmartDev.action }} Smartility Device
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                v-model="lSmartDev.smart_dev_type"
                label="Type"
                :items="smartDevTypes"
                item-value="smart_dev_id"
                item-text="smart_dev_type"
                :rules="[rules.required]"
                hide-details
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lSmartDev.smart_dev_sno"
                label="Serial Number"
                hide-details
                maxlength="10"
                :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-model="lSmartDev.smart_dev_loc"
                label="Location"
                maxlength="10"
                :rules="[rules.required]"
                hide-details
                ></v-text-field>
              </v-flex>
              <!-- device specific config -->
              <v-flex xs12 v-if="lSmartDev.smart_dev_type === 'FaceCheckin'">
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class="primary--text mt-2">Purpose</div>
                  </v-flex>
                  <v-flex xs12>
                    <v-radio-group
                    row class="ma-0" v-model="lSmartDev.fcDevPurpose"
                    hide-details
                    >
                    <v-radio
                    label="Time & Attendance"
                    value="T"
                    ></v-radio>
                    <v-radio
                    label="Others"
                    value="O"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12>
                  <div class="primary--text mt-2">Mode</div>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group
                  row class="ma-0" v-model="lSmartDev.fc_inout_mode"
                  hide-details
                  >
                  <v-radio
                  label="IN/OUT"
                  value="IN/OUT"
                  ></v-radio>
                  <v-radio
                  label="IN Only"
                  value="IN"
                  ></v-radio>
                  <v-radio
                  label="OUT Only"
                  value="OUT"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12>
                <div class="primary--text mt-2">Voice settings</div>
              </v-flex>
              <v-flex xs12>
                <v-switch
                v-model="lSmartDev.fc_is_voice_enabled"
                label="Voice enabled"
                hide-details
                ></v-switch>
              </v-flex>
              <v-flex xs12>
                <v-switch
                v-model="lSmartDev.fc_is_name_read"
                label="Pronounce user name"
                hide-details
                :disabled="!lSmartDev.fc_is_voice_enabled"
                ></v-switch>
              </v-flex>
              <v-flex xs12>
                <v-select
                v-model="lSmartDev.fcLangList"
                label="Languages"
                :items="['eng', 'hi', 'kn', 'ms', 'ta']"
                :disabled="!lSmartDev.fc_is_voice_enabled"
                :menu-props="{ top: true, offsetY: true }"
                hide-details
                >
              </v-select>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions class="pt-0">
      <v-spacer></v-spacer>
      <v-btn flat @click.stop="showIoTDevices = false">Cancel</v-btn>
      <v-btn flat v-if="lSmartDev.action === 'Update'" @click="deleteSmartDevice(lSmartDev)">delete</v-btn>
      <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
    </v-card-actions>
  </v-card>
</v-form>
</v-flex>
</v-container>
</v-dialog>

<!--Creating and updating the Compliance Category-->
<v-dialog v-model="showComplianceCategory" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="compCatForm" @submit.prevent="saveComplianceCategory(lCompCat.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lCompCat.action }} Compliance Category
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="lCompCat.name"
                  label="Name"
                  :rules="[rules.required]"
                  hide-details
                  maxlength="50"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showComplianceCategory = false">Cancel</v-btn>
            <v-btn flat v-if="lCompCat.action === 'Update'" @click="deleteComplianceCategory(lCompCat)">Delete</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!--Creating and updating the Compliance Subcategory-->

<!--Creating and updating the Compliance Type-->
<v-dialog v-model="showComplianceType" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-flex xs12 mx-auto>
      <v-form ref="compTypeForm" @submit.prevent="saveComplianceType(lCompType.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lCompType.action }} Compliance Type
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="lCompType.name"
                  label="Name"
                  :rules="[rules.required]"
                  hide-details
                  maxlength="50"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showComplianceType = false">Cancel</v-btn>
            <v-btn flat v-if="lCompType.action === 'Update'" @click="deleteComplianceType(lCompType)">Delete</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!--Creating and updating the Compliance Subcategory-->
<v-dialog v-model="showComplianceSubcat" persistent max-width="500px">
  <v-container grid-list-md class="pa-0" fluid>
    <v-flex xs12 mx-auto>
      <v-form ref="compSubcatForm" @submit.prevent="saveComplianceSubcategory(lCompSubcat.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lCompSubcat.action }} Compliance Subcategory
          </v-card-title>

          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="lCompSubcat.name"
                  label="Name"
                  :rules="[rules.required]"
                  hide-details
                  maxlength="50"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-select
                  v-model="lCompSubcat.category_id"
                  :items="complianceCategoryList"
                  item-text="name"
                  item-value="id"
                  label="Compliance Category"
                  :rules="[rules.required]"
                  hide-details
                  class="mb-3"
                ></v-select>
              </v-flex>

            </v-layout>
          </v-card-text>

          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showComplianceSubcat = false">Cancel</v-btn>
            <v-btn
              flat
              v-if="lCompSubcat.action === 'Update'"
              @click="deleteComplianceSubcategory(lCompSubcat)"
            >
              Delete
            </v-btn>
            <v-btn
              flat
              type="submit"
              color="accent"
              :disabled="beingSaved"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!--Creating and updating the Compliance-->
<v-dialog v-model="showCompliance" persistent max-width="800px">
  <v-container grid-list-md class="pa-0" fluid>
    <v-flex xs12 mx-auto>
      <v-form ref="complianceForm" @submit.prevent="saveCompliance(lCompliance.action)">
        <v-card flat>
          <v-card-title class="title grey lighten-4">
            {{ lCompliance.action }} Compliance
          </v-card-title>

          <v-card-text>
            <v-layout row wrap>
              <!-- Name -->
              <v-flex xs12>
                <v-text-field
                  v-model="lCompliance.name"
                  label="Name *"
                  :rules="[rules.required]"
                  maxlength="100"
                ></v-text-field>
              </v-flex>

              <!-- Compliance Type -->
              <v-flex xs12 sm6>
                <v-select
                  v-model="lCompliance.compliance_type_id"
                  :items="complianceTypeList"
                  item-text="name"
                  item-value="compliance_type_id"
                  label="Compliance Type *"
                  :rules="[rules.required]"
                ></v-select>
              </v-flex>

              <!-- Compliance Category -->
              <v-flex xs12 sm6>
                <v-select
                  v-model="lCompliance.compliance_category_id"
                  :items="complianceCategoryList"
                  item-text="name"
                  item-value="id"
                  label="Compliance Category *"
                  :rules="[rules.required]"
                  @change="onComplianceCategoryChange"
                ></v-select>
              </v-flex>

              <!-- Compliance Subcategory -->
              <v-flex xs12 sm6>
                <v-select
                  v-model="lCompliance.compliance_subcategory_id"
                  :items="filteredComplianceSubcategories"
                  item-text="name"
                  item-value="id"
                  label="Compliance Subcategory *"
                  :rules="[rules.required]"
                  :disabled="!lCompliance.compliance_category_id"
                ></v-select>
              </v-flex>

              <!-- Cost -->
              <v-flex xs12 sm6>
                <v-text-field
                  v-model.number="lCompliance.cost"
                  label="Cost (₹)"
                  type="number"
                  step="0.01"
                  min="0"
                ></v-text-field>
              </v-flex>

              <!-- Valid From -->
              <v-flex xs12 sm6>
                <v-menu
                  v-model="validFromMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="lCompliance.valid_from"
                      label="Valid From (Start/Issue Date) *"
                      readonly
                      v-on="on"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="lCompliance.valid_from"
                    @input="validFromMenu = false"
                    :allowed-dates="allowedValidFromDates"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <!-- Valid To -->
              <v-flex xs12 sm6>
                <v-menu
                  v-model="validToMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="lCompliance.valid_to"
                      label="Valid To (Expiry Date) *"
                      readonly
                      v-on="on"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="lCompliance.valid_to"
                    @input="validToMenu = false"
                    :min="lCompliance.valid_from"
                    :allowed-dates="allowedValidToDates"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <!-- Notify Before Days -->
              <v-flex xs12 sm6>
                <v-text-field
                  v-model.number="lCompliance.notify_before_days"
                  label="Notify Before Days"
                  type="number"
                  min="0"
                  hint="Number of days before expiry to send notification"
                ></v-text-field>
              </v-flex>

              <!-- Frequency -->
              <v-flex xs12 sm6>
                <v-select
                  v-model="lCompliance.frequency"
                  :items="['Yearly', 'Half-yearly', 'Quarterly', 'Monthly', 'Onetime']"
                  label="Frequency *"
                  :rules="[rules.required]"
                ></v-select>
              </v-flex>

              <!-- Remarks -->
              <v-flex xs12>
                <v-textarea
                  v-model="lCompliance.remarks"
                  label="Remarks"
                  rows="3"
                  hint="Additional notes or comments"
                ></v-textarea>
              </v-flex>

              <!-- Show on Dashboard -->
              <v-flex xs12 sm6 class="d-flex align-center">
                <v-checkbox
                  v-model="lCompliance.show_dashboard"
                  label="Show on Dashboard"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </v-flex>

              <!-- File Attachments -->
              <v-flex xs12>
                <v-subheader class="pa-0">Attachments</v-subheader>
                <input
                  style="display:none"
                  type="file"
                  ref="complianceFileInput"
                  accept=".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg"
                  multiple
                  @change="loadComplianceFilesFromBrowser($event)"
                />
                <v-btn small color="primary" @click="pickComplianceFile">
                  <v-icon left>attach_file</v-icon>
                  Upload Files
                </v-btn>

                <!-- Display uploaded files -->
                <v-layout row wrap class="mt-2" v-if="lCompliance.files && lCompliance.files.filter(f => f.is_selected).length > 0">
                  <v-flex xs12>
                    <div v-for="(file, index) in lCompliance.files" :key="index" class="mb-2">
                      <v-chip
                        v-if="file.is_selected"
                        close
                        @input="removeComplianceFile(file)"
                        color="primary"
                        text-color="white"
                      >
                        <v-icon left small>{{ getFileIcon(file.file_name) }}</v-icon>
                        {{ file.file_name }}
                        <v-btn
                          v-if="!file.is_changed && file.file_url"
                          small
                          icon
                          @click.stop="downloadComplianceFile(file)"
                          class="ml-2"
                        >
                          <v-icon small color="white">file_download</v-icon>
                        </v-btn>
                      </v-chip>
                    </div>
                  </v-flex>
                </v-layout>

                <div v-else class="caption grey--text mt-2">
                  No attachments. Click "Upload Files" to add documents (images, pdfs, docs and excels up to 20MB)
                </div>
              </v-flex>

            </v-layout>
          </v-card-text>

          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="showCompliance = false">Cancel</v-btn>
            <v-btn
              flat
              v-if="lCompliance.action === 'Update'"
              @click="deleteCompliance(lCompliance)"
            >
              Delete
            </v-btn>
            <v-btn
              flat
              type="submit"
              color="accent"
              :disabled="beingSaved"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-container>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar" :timeout="3000" multi-line>
  <span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<style>
.handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
}
</style>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import Sortable from 'sortablejs'

export default {
  data () {
    return {
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      beingSaved: false,
      handy: handy,
      rules: handy.rules,
      blockList: [],
      lBlock: [],
      lCompCat: [],
      lCompType: [],
      lCompSubcat: [],
      lCompliance: {
        action: 'Create',
        compliance_id: null,
        name: '',
        compliance_type_id: null,
        compliance_category_id: null,
        compliance_subcategory_id: null,
        remarks: '',
        frequency: '',
        valid_from: '',
        valid_to: '',
        show_dashboard: false,
        notify_before_days: 0,
        cost: null,
        files: []
      },
      validFromMenu: false,
      validToMenu: false,
      complianceTypeList: [],
      complianceCategoryList: [],
      complianceSubcatList: [],
      complianceList: [],
      complianceTypeHeaders: [
        { text: 'Name', value: 'name' }
      ],
      complianceCategoryHeaders: [
        { text: 'Name', value: 'name' }
      ],
      complianceSubcatHeaders: [
        { text: 'Subcategory Name', value: 'name' },
        { text: 'Category Name', value: 'category_name' }
      ],
      complianceHeaders: [
        { text: 'Name', value: 'compliance_name' },
        { text: 'Category', value: 'category_name' },
        { text: 'Subcategory', value: 'subcategory_name' },
        { text: 'Valid From', value: 'valid_from' },
        { text: 'Valid To', value: 'valid_to' },
        { text: 'Cost (₹)', value: 'cost' },
        { text: 'Dashboard', value: 'show_dashboard' },
        { text: 'Validity Status', value: 'validity_status' }
      ],
      facSet: [
        { text: 'Block', value: 'block_nm' },
        { text: 'Floors', value: 'floors' },
        { text: 'Flats', value: 'flats' }
      ],
      waterStorage: [
        { text: 'Tank Name', value: 'storage_nm' },
        { text: 'Category', value: 'water_cat' },
        { text: 'Tank Capacity (ltr)', value: 'storage_cap' },
        { text: 'Level Checked?', value: 'is_level_checked' },
        // { text: 'Receipt Checked?', value: 'is_receipt_checked' },
        { text: 'Cons Checked?', value: 'is_cons_checked' }
      ],
      waterStorageSm: [
        { text: 'Tank Name', value: 'storage_nm' },
        { text: 'Category', value: 'water_cat' },
        { text: 'Tank Capacity (ltr)', value: 'storage_cap' }
      ],
      storageList: [],
      lStorage: [],
      powerMeter: [
        { text: 'Meter Name', value: 'meter_nm' },
        { text: 'Location', value: 'meter_location' },
        { text: 'Area Covered', value: 'area_covered' }
      ],
      lPowerMeter: [],
      meterList: [],
      genSets: [
        { text: 'Name', value: 'genset_nm' },
        { text: 'Rating', value: 'genset_rating' },
        { text: 'Diesal Capacity (ltr)', value: 'genset_cap' }
      ],
      genSetsSm: [
        { text: 'Name', value: 'genset_nm' },
        { text: 'Rating', value: 'genset_rating' },
        { text: 'Diesal Cap (ltr)', value: 'genset_cap' }
      ],
      gensetList: [],
      lGen: [],
      cusMet: [
        { text: 'Metric Category', value: 'metric_cat' },
        { text: 'Metric Name', value: 'metric_nm' },
        { text: 'Total/Average', value: 'period_display' }
      ],
      metricList: [],
      lCusMet: [],
      hygHead: [
        { text: 'Category', value: 'check_cat' },
        { text: 'Description', value: 'check_desc' }
      ],
      sanCheckList: [],
      lSanCheck: [],
      showSanChecks: false,
      smartDev: [
        { text: 'Type', value: 'smart_dev_type' },
        { text: 'Serial Number', value: 'smart_dev_sno' },
        { text: 'Location', value: 'smart_dev_loc' }
      ],
      smartDevTypes: [],
      att_dev_type: [],
      deviceList: [],
      watType: [
        { text: 'Water type', value: 'water_type' },
        { text: 'Is Source?', value: 'is_source' }
      ],
      typeList: [],
      masterTypeList: [],
      lWaterType: [],
      paramList: [],
      watQual: [
        { text: '', value: '' },
        { text: 'Water Type', value: 'water_type' },
        { text: 'Parameter Name', value: 'param_name' },
        { text: 'UoM', value: 'uom' },
        { text: 'Min', value: 'std_val_min' },
        { text: 'Max', value: 'std_val_max' }
      ],
      watQualsm: [
        { text: '', value: '' },
        { text: 'Water Type', value: 'water_type' },
        { text: 'Param Name', value: 'param_name' },
        { text: 'UoM', value: 'uom' }
      ],
      qualList: [],
      lWaterQual: [],
      lPhotoCat: [],
      photoCat: [],
      photoCatHeader: [
        { text: 'Category Name', value: 'cat_name' }
      ],
      lSmartDev: [],
      showBlock: false,
      showWaterType: false,
      showWaterQuality: false,
      showWaterStorage: false,
      showPowerMeter: false,
      showGenset: false,
      showCustomMetric: false,
      showIoTDevices: false,
      showPhotoCat: false,
      showComplianceCategory: false,
      showComplianceType: false,
      showComplianceSubcat: false,
      showCompliance: false,
      secPostList: [],
      secPostHeader: [
        { text: 'Post Name', value: 'security_post' }
      ],
      showSecPost: false,
      lSecPost: {},
      lReport: []
    }
  },
  computed: {
    filteredComplianceSubcategories () {
      if (!this.lCompliance.compliance_category_id) {
        return []
      }
      return this.complianceSubcatList.filter(
        sub => sub.category_id === this.lCompliance.compliance_category_id
      )
    },
    allowedValidFromDates () {
      return (date) => {
        return true
      }
    },
    allowedValidToDates () {
      return (date) => {
        return true
      }
    }
  },
  created () {
    this.qualList = []
    this.loadWaterQuality()
  },
  mounted () {
    this.dragElement()
    this.loadBlocks()
    this.loadWaterStorage()
    this.loadPowerMeter()
    this.loadGensets()
    this.loadCustomMetric()
    this.loadSmartDevTypes()
    this.loadSmartDevice()
    this.loadWaterType()
    this.loadMasterWaterType()
    this.loadPhotoCat()
    this.loadSanCheckCat()
    this.loadSecPosts()
    this.loadDailyReportMailIds()
    this.loadWeeklyReportMailIds()
    this.loadOtherConfigs()
    this.loadComplianceType()
    this.loadComplianceCategory()
    this.loadCompliance()
  },
  methods: {
    dragElement () {
      let table = document.querySelector('.tblWaterQual tbody')
      const self = this
      Sortable.create(table, {
        handle: '.handle',
        onEnd ({ newIndex, oldIndex }) {
          const rowSelected = self.qualList.splice(oldIndex, 1)[0]
          self.qualList.splice(newIndex, 0, rowSelected)
          self.qualList[newIndex].disp_order = newIndex
          self.qualList[newIndex].oldIndex = oldIndex
          self.qualList[newIndex].comm_id = config.COMM_ID
          self.saveWatQualIndex(self.qualList[newIndex])
        }
      })
    },
    saveWatQualIndex (curWatQualList) {
      this.axios.post(config.API_URL + '/waterquality/index', curWatQualList)
      .then(response => {
        setTimeout(() => {
          this.loadWaterQuality()
        }, 1000)
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadBlocks () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getBlocksByCommId/', qry)
      .then(response => {
        this.blockList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    prepareCreateBlock () {
      this.lBlock = {
        comm_id: config.COMM_ID,
        block_nm: '',
        floors: '',
        flats: ''
      }
      this.lBlock.action = 'Create'
      this.showBlock = true
    },
    prepareEditBlock (curBlock) {
      this.lBlock = Object.assign({}, curBlock) // keep the original object safely before changes
      this.lBlock.action = 'Update'
      this.showBlock = true
    },
    saveChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        if (!this.lBlock.block_nm) {
          this.msg('Please enter block name', 0)
          return
        }
        this.beingSaved = true
        this.axios.post(config.API_URL + '/facBlock/' + action, this.lBlock)
        .then(response => {
          if (action === 'Create') {
            this.lBlock.block_id = response.data
            this.blockList.push(this.lBlock)
          } else {
            this.idx = this.blockList.findIndex(rec => rec.block_id === this.lBlock.block_id)
            Object.assign(this.blockList[this.idx], this.lBlock)
          }
          this.beingSaved = false
          this.showBlock = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
          this.showBlock = false
        })
      }
    },
    deleteBlock (curBlock) {
      if (!confirm('Sure, you want to delete the Block "' + curBlock.block_nm + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/facBlock/delete', this.lBlock)
      .then(response => {
        this.idx = this.blockList.findIndex(rec => rec.block_id === this.lBlock.block_id)
        this.blockList.splice(this.idx, 1)
        this.beingSaved = false
        this.showBlock = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
        this.showBlock = false
      })
    },
    loadWaterStorage () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getWaterStorageByCommId/', qry)
      .then(response => {
        this.storageList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    prepareCreateStorage () {
      this.lStorage = {
        comm_id: config.COMM_ID,
        storage_nm: '',
        storage_cap: '',
        water_cat: 'Domestic',
        is_level_checked: false,
        is_receipt_checked: false,
        is_cons_checked: false,
        rtm_provider: null,
        rtm_integrate_id_1: null,
        min_level: null,
        max_level: null,
        is_alarm_on: false
      }
      this.lStorage.action = 'Create'
      this.showWaterStorage = true
    },
    saveStorageChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        if (!this.lStorage.storage_nm) {
          this.msg('Please enter storage name', 0)
          return
        }
        if (this.lStorage.min_level) {
          if (this.lStorage.min_level < 0 || this.lStorage.min_level > 100) {
            this.msg('Please add the value of min water level between 0-100 only', 0)
            return
          }
        }
        if (this.lStorage.max_level) {
          if (this.lStorage.max_level < 0 || this.lStorage.max_level > 100) {
            this.msg('Please add the value of max water level between 0-100 only', 0)
            return
          }
        }
        this.beingSaved = true
        this.lStorage.storage_cap = this.lStorage.storage_cap ? this.lStorage.storage_cap : null
        this.axios.post(config.API_URL + '/waterStorage/' + action, this.lStorage)
        .then(response => {
          if (action === 'Create') {
            this.lStorage.storage_id = response.data
            this.storageList.push(this.lStorage)
          } else {
            this.idx = this.storageList.findIndex(rec => rec.storage_id === this.lStorage.storage_id)
            Object.assign(this.storageList[this.idx], this.lStorage)
          }
          this.beingSaved = false
          this.showWaterStorage = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    prepareEditStorage (curStorage) {
      this.lStorage = Object.assign({}, curStorage) // keep the original object safely before changes
      this.lStorage.action = 'Update'
      this.showWaterStorage = true
    },
    deleteStorage (curStorage) {
      if (!confirm('Sure, you want to delete the Water Storage "' + curStorage.storage_nm + '"? \nWARNING: This will also delete all associated records in facility daily update')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/waterStorage/delete', this.lStorage)
      .then(response => {
        this.idx = this.storageList.findIndex(rec => rec.storage_id === this.lStorage.storage_id)
        this.storageList.splice(this.idx, 1)
        this.beingSaved = false
        this.showWaterStorage = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    loadPowerMeter () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getPowerMeterByCommId/', qry)
      .then(response => {
        this.meterList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    prepareCreateMeter () {
      this.lPowerMeter = {
        comm_id: config.COMM_ID,
        meter_nm: '',
        meter_location: '',
        area_covered: ''
      }
      this.lPowerMeter.action = 'Create'
      this.showPowerMeter = true
    },
    saveMeterChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        if (!this.lPowerMeter.area_covered) {
          this.msg('Please enter area covered section to reflect it in daily report', 0)
        } else {
          this.beingSaved = true
          this.axios.post(config.API_URL + '/powerMeter/' + action, this.lPowerMeter)
          .then(response => {
            if (action === 'Create') {
              this.lPowerMeter.meter_id = response.data
              this.meterList.push(this.lPowerMeter)
            } else {
              this.idx = this.meterList.findIndex(rec => rec.meter_id === this.lPowerMeter.meter_id)
              Object.assign(this.meterList[this.idx], this.lPowerMeter)
            }
            this.beingSaved = false
            this.showPowerMeter = false
          })
          .catch(err => {
            this.msg(err.response.data, 0)
            this.beingSaved = false
          })
        }
      }
    },
    prepareEditMeter (curMeter) {
      this.lPowerMeter = Object.assign({}, curMeter) // keep the original object safely before changes
      this.lPowerMeter.action = 'Update'
      this.showPowerMeter = true
    },
    deleteMeter (curMeter) {
      if (!confirm('Sure, you want to delete the Power Meter "' + curMeter.meter_nm + '"? \nWARNING: This will also delete all associated records in facility daily update')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/powerMeter/delete', this.lPowerMeter)
      .then(response => {
        this.idx = this.meterList.findIndex(rec => rec.meter_id === this.lPowerMeter.meter_id)
        this.meterList.splice(this.idx, 1)
        this.beingSaved = false
        this.showPowerMeter = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    loadGensets () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getGenSetByCommId/', qry)
      .then(response => {
        this.gensetList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    prepareCreateGensets () {
      this.lGen = {
        comm_id: config.COMM_ID,
        genset_nm: '',
        genset_rating: '',
        genset_cap: ''
      }
      this.lGen.action = 'Create'
      this.showGenset = true
    },
    saveGenChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        if (!this.lGen.genset_nm) {
          this.msg('Please enter genset name', 0)
          return
        }
        this.beingSaved = true
        this.lGen.genset_cap = this.lGen.genset_cap ? this.lGen.genset_cap : null
        this.axios.post(config.API_URL + '/genset/' + action, this.lGen)
        .then(response => {
          if (action === 'Create') {
            this.lGen.genset_id = response.data
            this.gensetList.push(this.lGen)
          } else {
            this.idx = this.gensetList.findIndex(rec => rec.genset_id === this.lGen.genset_id)
            Object.assign(this.gensetList[this.idx], this.lGen)
          }
          this.beingSaved = false
          this.showGenset = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    prepareEditGensets (curGen) {
      this.lGen = Object.assign({}, curGen) // keep the original object safely before changes
      this.lGen.action = 'Update'
      this.showGenset = true
    },
    deleteGen (curGen) {
      if (!confirm('Sure, you want to delete the Genset "' + curGen.genset_nm + '"? \nWARNING: This will also delete all associated records in facility daily update')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/genset/delete', this.lGen)
      .then(response => {
        this.idx = this.gensetList.findIndex(rec => rec.genset_id === this.lGen.genset_id)
        this.gensetList.splice(this.idx, 1)
        this.beingSaved = false
        this.showGenset = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    loadCustomMetric () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getCusMetByCommId/', qry)
      .then(response => {
        this.metricList = handy.unique(response.data.filter(rec => rec.metric_nm !== ''))
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    prepareCreateCusMet () {
      this.lCusMet = {
        comm_id: config.COMM_ID,
        metric_cat: '',
        metric_nm: '',
        period_display: 'T'
      }
      this.lCusMet.action = 'Create'
      this.showCustomMetric = true
    },
    saveCustomMetChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        if (!this.lCusMet.metric_cat || !this.lCusMet.metric_nm) {
          this.msg('Please enter all mandatory field', 0)
          return
        }
        this.beingSaved = true
        this.axios.post(config.API_URL + '/metric/' + action, this.lCusMet)
        .then(response => {
          if (action === 'Create') {
            this.lCusMet.metric_id = response.data
            this.metricList.push(this.lCusMet)
          } else {
            this.idx = this.metricList.findIndex(rec => rec.metric_id === this.lCusMet.metric_id)
            Object.assign(this.metricList[this.idx], this.lCusMet)
          }
          this.beingSaved = false
          this.showCustomMetric = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    prepareEditCusMet (curMet) {
      this.lCusMet = Object.assign({}, curMet) // keep the original object safely before changes
      this.lCusMet.metric_cat_pair = { metric_cat: this.lCusMet.metric_cat, metric_id: this.lCusMet.metric_id }
      this.lCusMet.action = 'Update'
      this.showCustomMetric = true
    },
    deleteMet (curMet) {
      if (!confirm('Sure, you want to delete the Metric "' + curMet.metric_cat + '"? \nWARNING: This will also delete all associated records in facility daily update')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/metric/delete', this.lCusMet)
      .then(response => {
        this.idx = this.metricList.findIndex(rec => rec.metric_id === this.lCusMet.metric_id)
        this.metricList.splice(this.idx, 1)
        this.beingSaved = false
        this.showCustomMetric = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    loadSmartDevice () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getSmartDeviceByCommId/', qry)
      .then(response => {
        this.deviceList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    prepareCreateSmartDevice () {
      this.lSmartDev = {
        comm_id: config.COMM_ID,
        smart_dev_type: '',
        smart_dev_sno: '',
        smart_dev_loc: '',
        // default for facecheckin device
        fcDevPurpose: 'T',
        fc_inout_mode: 'IN/OUT',
        fc_is_voice_enabled: true,
        fc_is_name_read: true,
        fcLangList: ['eng']
      }
      this.lSmartDev.action = 'Create'
      this.showIoTDevices = true
    },
    saveSmartDeviceChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        this.beingSaved = true
        // pre-processing
        this.lSmartDev.fc_is_ta_dev = this.lSmartDev.fcDevPurpose === 'T'
        this.lSmartDev.fc_lang_code_list = Array.isArray(this.lSmartDev.fcLangList) ? this.lSmartDev.fcLangList.join(',') : (this.lSmartDev.fcLangList || '')
        // for MS face
        this.lSmartDev.comm_id = config.COMM_ID
        this.lSmartDev.comm_name = config.COMM_NAME
        this.axios.post(config.API_URL + '/smartdevice/' + action, this.lSmartDev)
        .then(response => {
          this.idx = -1
          if (action === 'Create') {
            this.lSmartDev.smart_dev_id = response.data
            this.deviceList.push(this.lSmartDev)
          } else {
            this.idx = this.deviceList.findIndex(rec => rec.smart_dev_id === this.lSmartDev.smart_dev_id)
            Object.assign(this.deviceList[this.idx], this.lSmartDev)
          }
          this.beingSaved = false
          this.showIoTDevices = false
        })
        .catch(err => {
          this.msg(err, 0)
          this.beingSaved = false
        })
      }
    },
    prepareEditSmartDevice (curDev) {
      this.lSmartDev = Object.assign({}, curDev) // keep the original object safely before changes
      this.lSmartDev.fcDevPurpose = this.lSmartDev.fc_is_ta_dev ? 'T' : 'O'
      this.lSmartDev.fcLangList = this.lSmartDev.fc_lang_code_list ? this.lSmartDev.fc_lang_code_list.split(',')[0] : ''
      this.lSmartDev.old_smart_dev_type = this.lSmartDev.smart_dev_type
      this.lSmartDev.old_smart_dev_sno = this.lSmartDev.smart_dev_sno
      this.lSmartDev.action = 'Update'
      this.showIoTDevices = true
    },
    deleteSmartDevice (curDev) {
      if (!confirm('Sure, you want to delete the Smartility device with serial no. "' + curDev.smart_dev_sno + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/smartdevice/delete', this.lSmartDev)
      .then(response => {
        this.idx = this.deviceList.findIndex(rec => rec.smart_dev_id === this.lSmartDev.smart_dev_id)
        this.deviceList.splice(this.idx, 1)
        this.beingSaved = false
        this.showIoTDevices = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    loadWaterType () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getWaterTypeByCommId/', qry)
      .then(response => {
        this.typeList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadMasterWaterType () {
      var qry = {
        params: {
          vendor_id: config.FM_VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getMasterWaterTypeByVendorId/', qry)
      .then(response => {
        this.masterTypeList = response.data.map(rec => rec.water_type)
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadWaterQualityReference (curWaterTypeId) {
      var qry = {
        params: {
          vendor_id: config.FM_VENDOR_ID,
          comm_id: config.COMM_ID,
          water_type_id: curWaterTypeId
        }
      }
      this.axios.get(config.API_URL + '/getWaterQualityReferenceByCommId/', qry)
      .then(response => {
        this.paramList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadBasedParamName (curParamName, curWaterTypeId) {
      if (curParamName) {
        var tmpWaterQual = this.paramList.filter(rec => rec.param_name === curParamName)
        this.lWaterQual.std_val_min = tmpWaterQual[0].std_val_min ? tmpWaterQual[0].std_val_min : 0
        this.lWaterQual.std_val_max = tmpWaterQual[0].std_val_max
        this.lWaterQual.uom = tmpWaterQual[0].uom
        this.lWaterQual.param_name = tmpWaterQual[0].param_name
        this.lWaterQual.water_type_id = curWaterTypeId
      }
    },
    prepareCreateWaterType () {
      this.lWaterType = {
        comm_id: config.COMM_ID,
        water_type: ''
      }
      this.lWaterType.action = 'Create'
      this.showWaterType = true
    },
    saveWaterTypeChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        if (!this.lWaterType.water_type) {
          this.msg('Please select water type', 0)
          return
        }
        this.beingSaved = true
        this.axios.post(config.API_URL + '/watertype/' + action, this.lWaterType)
        .then(response => {
          if (action === 'Create') {
            this.loadWaterType()
          } else {
            this.idx = this.typeList.findIndex(rec => rec.water_type_id === this.lWaterType.water_type_id)
            Object.assign(this.typeList[this.idx], this.lWaterType)
          }
          this.beingSaved = false
          this.showWaterType = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    prepareEditWaterType (curWatType) {
      this.lWaterType = Object.assign({}, curWatType) // keep the original object safely before changes
      this.loadMasterWaterType()
      this.lWaterType.action = 'Update'
      this.showWaterType = true
    },
    deleteWaterType (curWatType) {
      if (!confirm('Sure, you want to delete the water type with name "' + curWatType.water_type + '"? \nWARNING: This will also delete all associated records in facility daily update')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/watertype/delete', this.lWaterType)
      .then(response => {
        this.idx = this.typeList.findIndex(rec => rec.water_type_id === this.lWaterType.water_type_id)
        this.typeList.splice(this.idx, 1)
        this.loadWaterStorage()
        this.loadWaterQuality()
        this.beingSaved = false
        this.showWaterType = false
      })
      .catch(err => {
        console.log(err)
        this.msg('Before deleting water types, delete the records from Water Quality', 0)
        this.beingSaved = false
      })
    },
    loadWaterQuality () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getWaterQualityByCommId/', qry)
      .then(response => {
        this.qualList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    prepareCreateWaterQual () {
      this.lWaterQual = {
        water_type_pair: {},
        param_name: '',
        uom: '',
        std_val_min: null,
        std_val_max: null
      }
      this.lWaterQual.action = 'Create'
      this.showWaterQuality = true
    },
    saveWatQualChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        if (!this.lWaterQual.water_type_pair.water_type) {
          this.msg('Please select water type', 0)
          return
        }
        this.beingSaved = true
        this.lWaterQual.water_type = this.lWaterQual.water_type_pair.water_type
        this.lWaterQual.water_type_id = this.lWaterQual.water_type_pair.water_type_id
        this.axios.post(config.API_URL + '/waterquality/' + action, this.lWaterQual)
        .then(response => {
          if (action === 'Create') {
            this.lWaterQual.param_id = response.data
            this.qualList.push(this.lWaterQual)
          } else {
            this.idx = this.qualList.findIndex(rec => rec.param_id === this.lWaterQual.param_id)
            Object.assign(this.qualList[this.idx], this.lWaterQual)
          }
          this.beingSaved = false
          this.showWaterQuality = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    prepareEditWaterQual (curWatQual) {
      this.lWaterQual = Object.assign({}, curWatQual) // keep the original object safely before changes
      this.lWaterQual.water_type_pair = { water_type_id: curWatQual.water_type_id, water_type: curWatQual.water_type }
      this.lWaterQual.action = 'Update'
      this.showWaterQuality = true
    },
    deleteQual (curWatQual) {
      if (!confirm('Sure, you want to delete the water quality param "' + curWatQual.water_type + '"? \nWARNING: This will also delete all associated records in facility daily update')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/waterquality/delete', this.lWaterQual)
      .then(response => {
        this.idx = this.qualList.findIndex(rec => rec.param_id === this.lWaterQual.param_id)
        this.qualList.splice(this.idx, 1)
        this.beingSaved = false
        this.showWaterQuality = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    loadPhotoCat () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getPhotoCatByCommId/', qry)
      .then(response => {
        this.photoCat = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    prepareCreatePhotoCat () {
      this.lPhotoCat = {
        comm_id: config.COMM_ID,
        attach_cat_name: ''
      }
      this.lPhotoCat.action = 'Create'
      this.showPhotoCat = true
    },
    savePhotoCat (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        if (!this.lPhotoCat.attach_cat_name) {
          this.msg('Please enter category name', 0)
          return
        }
        this.beingSaved = true
        this.axios.post(config.API_URL + '/photoCat/' + action, this.lPhotoCat)
        .then(response => {
          if (action === 'Create') {
            this.lPhotoCat.attach_cat_id = response.data
            this.photoCat.push(this.lPhotoCat)
          } else {
            this.idx = this.photoCat.findIndex(rec => rec.attach_cat_id === this.lPhotoCat.attach_cat_id)
            Object.assign(this.photoCat[this.idx], this.lPhotoCat)
          }
          this.beingSaved = false
          this.showPhotoCat = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    prepareEditPhotoCat (curPhotoCat) {
      this.lPhotoCat = Object.assign({}, curPhotoCat) // keep the original object safely before changes
      this.lPhotoCat.comm_id = config.COMM_ID
      this.lPhotoCat.action = 'Update'
      this.showPhotoCat = true
    },
    deletePhotoCat (curPhotoCat) {
      if (!confirm('Sure, you want to delete the photo category with name "' + curPhotoCat.attach_cat_name + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/photoCat/delete', this.lPhotoCat)
      .then(response => {
        this.idx = -1
        this.idx = this.photoCat.findIndex(rec => rec.attach_cat_id === this.lPhotoCat.attach_cat_id)
        if (this.idx > -1) {
          this.photoCat.splice(this.idx, 1)
        }
        this.beingSaved = false
        this.showPhotoCat = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    loadSanCheckCat () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getSanCheckListByCommId/', qry)
      .then(response => {
        this.sanCheckList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    prepareCreateSanCheck () {
      this.lSanCheck = {
        check_desc: '',
        check_cat: '',
        comm_id: config.COMM_ID
      }
      this.lSanCheck.action = 'Create'
      this.showSanChecks = true
    },
    saveSanCheckChanges (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.hForm.validate()) {
          return
        }
        this.beingSaved = true
        this.axios.post(config.API_URL + '/sanCheck/' + action, this.lSanCheck)
        .then(response => {
          if (action === 'Create') {
            this.lSanCheck.check_id = response.data
            this.sanCheckList.push(this.lSanCheck)
          } else {
            this.idx = this.sanCheckList.findIndex(rec => rec.check_id === this.lSanCheck.check_id)
            Object.assign(this.sanCheckList[this.idx], this.lSanCheck)
          }
          this.beingSaved = false
          this.showSanChecks = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    prepareEditSanCheck (curSanCheck) {
      this.lSanCheck = Object.assign({}, curSanCheck) // keep the original object safely before changes
      this.lSanCheck.action = 'Update'
      this.showSanChecks = true
    },
    deleteSanCheck (curSanCheck) {
      if (!confirm('Sure, you want to delete the category "' + curSanCheck.check_desc + '"? \nWARNING: This will also delete all associated records in facility daily update')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/sanCheck/delete', curSanCheck)
      .then(response => {
        this.idx = this.sanCheckList.findIndex(rec => rec.check_id === curSanCheck.check_id)
        this.sanCheckList.splice(this.idx, 1)
        this.beingSaved = false
        this.showSanChecks = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    loadSmartDevTypes () {
      this.axios.get(config.API_URL + '/getSmartDeviceTypes/')
      .then(response => {
        this.smartDevTypes = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadSecPosts () {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getSecurityPostsByCommId/', qry)
      .then(response => {
        this.secPostList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.secPostList = []
      })
    },
    prepareCreateSecPost () {
      this.lSecPost = {
        comm_id: config.COMM_ID,
        security_post: ''
      }
      this.lSecPost.action = 'Create'
      this.showSecPost = true
    },
    saveSecPost (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.pForm.validate()) {
          return
        }
        this.beingSaved = true
        this.axios.post(config.API_URL + '/secPost/' + action, this.lSecPost)
        .then(response => {
          if (action === 'Create') {
            this.lSecPost.security_post_id = response.data
            this.secPostList.push(this.lSecPost)
          } else {
            this.idx = this.secPostList.findIndex(rec => rec.security_post_id === this.lSecPost.security_post_id)
            Object.assign(this.secPostList[this.idx], this.lSecPost)
          }
          this.beingSaved = false
          this.showSecPost = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    prepareEditSecPost (curSecPost) {
      this.lSecPost = Object.assign({}, curSecPost) // keep the original object safely before changes
      this.lSecPost.action = 'Update'
      this.showSecPost = true
    },
    deleteSecPost () {
      if (!confirm('Sure, you want to delete the security post "' + this.lSecPost.security_post + '"?')) {
        return
      }
      // update the db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/secPost/delete', this.lSecPost)
      .then(response => {
        this.idx = this.secPostList.findIndex(rec => rec.security_post_id === this.lSecPost.security_post_id)
        this.secPostList.splice(this.idx, 1)
        this.beingSaved = false
        this.showSecPost = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    saveDailyReportMailIds (curMailList) {
      // update the db
      this.lReport = {
        comm_id: config.COMM_ID,
        email_list: curMailList
      }
      if (!this.lReport.email_list) {
        this.msg('Please enter mail id', 0)
        return
      }
      this.axios.post(config.API_URL + '/dailyReportMailIds/', this.lReport)
      .then(response => {
        this.msg('Saved Successfully', 1)
        this.loadDailyReportMailIds()
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    saveWeeklyReportMailIds (curMailList) {
      // update the db
      this.lReport = {
        comm_id: config.COMM_ID,
        email_wlist: curMailList
      }
      if (!this.lReport.email_wlist) {
        this.msg('Please enter mail id', 0)
        return
      }
      this.axios.post(config.API_URL + '/weeklyReportMailIds/', this.lReport)
      .then(response => {
        this.msg('Saved Successfully', 1)
        this.loadWeeklyReportMailIds()
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    saveOtherConfigs (AttType) {
      // update the db
      this.lReport = {
        comm_id: config.COMM_ID,
        att_dev_type: AttType
      }
      if (!this.lReport.att_dev_type) {
        this.msg('Please selece attendance device type', 0)
        return
      }
      this.axios.post(config.API_URL + '/attendancedevtype/', this.lReport)
      .then(response => {
        this.msg('Saved Successfully', 1)
        this.loadOtherConfigs()
      })
      .catch(err => {
        this.msg(err.response.data, 0)
      })
    },
    loadOtherConfigs () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getFacilityOtherConfigsByCommId/', qry)
      .then(response => {
        if (response.data.length) {
          this.lReport.att_dev_type = response.data[0].att_dev_type
          this.lReport.comm_id = response.data[0].comm_id
        } else {
          this.lReport.att_dev_type = ''
          this.lReport.comm_id = config.COMM_ID
        }
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.lReport = []
      })
    },
    loadDailyReportMailIds () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getDailyReportMailIdsByCommId/', qry)
      .then(response => {
        if (response.data.length) {
          this.lReport.email_list = response.data[0].email_list
          this.lReport.comm_id = response.data[0].comm_id
        } else {
          this.lReport.email_list = ''
          this.lReport.comm_id = config.COMM_ID
        }
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.lReport = []
      })
    },
    loadWeeklyReportMailIds () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getWeeklyReportMailIdsByCommId/', qry)
      .then(response => {
        if (response.data.length) {
          this.lReport.email_wlist = response.data[0].email_wlist
          this.lReport.comm_id = response.data[0].comm_id
        } else {
          this.lReport.email_wlist = ''
          this.lReport.comm_id = config.COMM_ID
        }
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.lReport = []
      })
    },
    prepareCreateComplianceType () {
      this.lCompType = {
        comm_id: config.COMM_ID,
        name: ''
      }
      this.lCompType.action = 'Create'
      this.showComplianceType = true
    },
    prepareEditComplianceType (item) {
      this.lCompType = Object.assign({}, item)
      this.lCompType.comm_id = config.COMM_ID
      this.lCompType.action = 'Update'
      this.showComplianceType = true
    },
    saveComplianceType (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.compTypeForm.validate()) {
          return
        }
        if (!this.lCompType.name) {
          this.msg('Please enter compliance type name', 0)
          return
        }
        this.beingSaved = true

        const endpoint = action === 'Create' ? '/compliance-type/create' : '/compliance-type/update'
        const payload = {
          name: this.lCompType.name,
          created_by: config.USER_ID,
          updated_by: config.USER_ID,
          community_id: config.COMM_ID
        }

        if (action === 'Update') {
          payload.id = this.lCompType.compliance_type_id
        }

        this.axios.post(config.API_URL + endpoint, payload)
        .then(response => {
          if (action === 'Create') {
            this.lCompType.compliance_type_id = response.data
            this.lCompType.created_by = config.USER_NAME || 'Current User'
            this.lCompType.updated_by = null
            this.lCompType.created_at = new Date().toISOString()
            this.complianceTypeList.push(Object.assign({}, this.lCompType))
            this.msg('Compliance type created successfully', 1)
          } else {
            const idx = this.complianceTypeList.findIndex(rec => rec.compliance_type_id === this.lCompType.compliance_type_id)
            this.lCompType.updated_by = config.USER_NAME || 'Current User'
            this.lCompType.updated_at = new Date().toISOString()
            Object.assign(this.complianceTypeList[idx], this.lCompType)
            this.msg('Compliance type updated successfully', 1)
          }
          this.beingSaved = false
          this.showComplianceType = false
        })
        .catch(err => {
          this.msg(err.response && err.response.data ? err.response.data : 'Error saving compliance type', 0)
          this.beingSaved = false
        })
      }
    },
    deleteComplianceType (curCompType) {
      if (!confirm('Sure, you want to delete the compliance type "' + curCompType.name + '"?')) {
        return
      }
      this.beingSaved = true

      const payload = { id: curCompType.compliance_type_id }

      this.axios.post(config.API_URL + '/compliance-type/delete', payload)
      .then(response => {
        const idx = this.complianceTypeList.findIndex(rec => rec.compliance_type_id === this.lCompType.compliance_type_id)
        if (idx > -1) {
          this.complianceTypeList.splice(idx, 1)
        }
        this.msg('Compliance type deleted successfully', 1)
        this.beingSaved = false
        this.showComplianceType = false
      })
      .catch(err => {
        this.msg(err.response && err.response.data ? err.response.data : 'Error deleting compliance type', 0)
        this.beingSaved = false
      })
    },
    prepareCreateComplianceCategory () {
      this.lCompCat = {
        comm_id: config.COMM_ID,
        name: ''
      }
      this.lCompCat.action = 'Create'
      this.showComplianceCategory = true
    },
    prepareEditComplianceCategory (item) {
      this.lCompCat = Object.assign({}, item)
      this.lCompCat.comm_id = config.COMM_ID
      this.lCompCat.action = 'Update'
      this.showComplianceCategory = true
    },
    saveComplianceCategory (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.compCatForm.validate()) {
          return
        }
        if (!this.lCompCat.name) {
          this.msg('Please enter category name', 0)
          return
        }
        this.beingSaved = true

        const requestBody = {
          name: this.lCompCat.name,
          community_id: config.COMM_ID,
          created_by: config.USER_ID,
          updated_by: config.USER_ID
        }

        if (action === 'Update') {
          requestBody.id = this.lCompCat.id
        }

        this.axios.post(config.API_URL + '/compliance-category/' + action.toLowerCase(), requestBody)
        .then(response => {
          if (action === 'Create') {
            this.lCompCat.id = response.data
            this.complianceCategoryList.push(Object.assign({}, this.lCompCat))
            this.msg('Compliance category created successfully', 1)
          } else {
            const idx = this.complianceCategoryList.findIndex(rec => rec.id === this.lCompCat.id)
            Object.assign(this.complianceCategoryList[idx], this.lCompCat)
            this.msg('Compliance category updated successfully', 1)
          }
          this.beingSaved = false
          this.showComplianceCategory = false
        })
        .catch(() => {
          this.msg('Error saving compliance category', 0)
          this.beingSaved = false
        })
      }
    },
    deleteComplianceCategory (curCompCat) {
      if (!confirm('Sure, you want to delete the compliance category "' + curCompCat.name + '"?')) {
        return
      }
      this.beingSaved = true

      this.axios.post(config.API_URL + '/compliance-category/delete', { id: curCompCat.id })
      .then(response => {
        const idx = this.complianceCategoryList.findIndex(rec => rec.id === curCompCat.id)
        if (idx > -1) {
          this.complianceCategoryList.splice(idx, 1)
        }
        this.msg('Compliance category deleted successfully', 1)
        this.beingSaved = false
        this.showComplianceCategory = false
      })
      .catch(err => {
        this.msg(err.response && err.response.data ? err.response.data : 'Error deleting compliance category', 0)
        this.beingSaved = false
      })
    },
    loadComplianceType () {
      this.axios.get(config.API_URL + '/getComplianceType?comm_id=' + config.COMM_ID)
      .then(response => {
        // Normalize the response to ensure consistent field naming
        this.complianceTypeList = response.data.map(item => ({
          ...item,
          compliance_type_id: item.id || item.compliance_type_id,
          id: item.id || item.compliance_type_id
        }))
      })
      .catch(() => {
        this.msg('Error loading compliance types', 0)
      })
    },
    loadComplianceCategory () {
      this.axios.get(config.API_URL + '/getComplianceCategory?comm_id=' + config.COMM_ID)
      .then(response => {
        this.complianceCategoryList = response.data
        // Load subcategories after categories are loaded
        this.loadComplianceSubcategory()
      })
      .catch(() => {
        this.msg('Error loading compliance categories', 0)
      })
    },
    loadComplianceSubcategory () {
      this.axios.get(config.API_URL + '/getComplianceSubcategory?comm_id=' + config.COMM_ID)
      .then(response => {
        this.complianceSubcatList = response.data
      })
      .catch(() => {
        this.msg('Error loading compliance subcategories', 0)
      })
    },
    loadCompliance () {
      this.axios.get(config.API_URL + '/getCompliance?comm_id=' + config.COMM_ID)
        .then(response => {
          // Calculate validity status for each compliance
          this.complianceList = response.data.map(item => {
            const validityStatus = this.calculateValidityStatus(item.valid_to, item.notify_before_days)
            return {
              ...item,
              validity_status: validityStatus
            }
          })
        })
        .catch(() => {
          this.msg('Error loading compliance records', 0)
        })
    },
    calculateValidityStatus (validTo, notifyBeforeDays) {
      if (!validTo) return 'Unknown'

      const today = new Date()
      today.setHours(0, 0, 0, 0)

      const validToDate = new Date(validTo)
      validToDate.setHours(0, 0, 0, 0)

      // Calculate days difference
      const diffTime = validToDate - today
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

      // Expired
      if (diffDays < 0) {
        return 'Expired'
      }

      // About to expire (within notify_before_days)
      const notifyDays = notifyBeforeDays || 30 // Default to 30 days if not set
      if (diffDays <= notifyDays) {
        return 'About to expire'
      }

      // Active
      return 'Active'
    },
    getCategoryName (complianceCatId) {
      const category = this.complianceCategoryList.find(cat => cat.id === complianceCatId)
      return category ? category.name : '-'
    },
    getComplianceCategoryName (complianceCategoryId) {
      const category = this.complianceCategoryList.find(cat => cat.id === complianceCategoryId)
      return category ? category.name : '-'
    },
    getComplianceSubcategoryName (complianceSubcategoryId) {
      const subcategory = this.complianceSubcatList.find(sub => sub.id === complianceSubcategoryId)
      return subcategory ? subcategory.name : '-'
    },
    formatDate (date) {
      if (!date) return '-'
      const d = new Date(date)
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getFullYear()
      return `${day}/${month}/${year}`
    },
    formatDateTime (dateTime) {
      if (!dateTime) return '-'
      const d = new Date(dateTime)
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getFullYear()
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      return `${day}/${month}/${year} ${hours}:${minutes}`
    },
    prepareCreateComplianceSubcategory () {
      this.lCompSubcat = {
        comm_id: config.COMM_ID,
        name: '',
        category_id: null
      }
      this.lCompSubcat.action = 'Create'
      this.showComplianceSubcat = true
    },
    prepareEditComplianceSubcategory (item) {
      this.lCompSubcat = Object.assign({}, item)
      this.lCompSubcat.action = 'Update'
      this.showComplianceSubcat = true
    },
    saveComplianceSubcategory (action) {
      if (action === 'Create' || action === 'Update') {
        if (!this.$refs.compSubcatForm.validate()) {
          return
        }
        if (!this.lCompSubcat.name) {
          this.msg('Please enter subcategory name', 0)
          return
        }
        if (!this.lCompSubcat.category_id) {
          this.msg('Please select compliance category', 0)
          return
        }
        this.beingSaved = true

        const requestBody = {
          complianceCategory_id: this.lCompSubcat.category_id,
          name: this.lCompSubcat.name,
          created_by: config.USER_ID,
          updated_by: config.USER_ID
        }

        if (action === 'Update') {
          requestBody.id = this.lCompSubcat.id
        }

        this.axios.post(config.API_URL + '/compliance-subcategory/' + action.toLowerCase(), requestBody)
        .then(response => {
          if (action === 'Create') {
            this.lCompSubcat.id = response.data
            this.complianceSubcatList.push(Object.assign({}, this.lCompSubcat))
            this.msg('Compliance subcategory created successfully', 1)
          } else {
            const idx = this.complianceSubcatList.findIndex(rec => rec.id === this.lCompSubcat.id)
            Object.assign(this.complianceSubcatList[idx], this.lCompSubcat)
            this.msg('Compliance subcategory updated successfully', 1)
          }
          this.beingSaved = false
          this.showComplianceSubcat = false
        })
        .catch(() => {
          this.msg('Error saving compliance subcategory', 0)
          this.beingSaved = false
        })
      }
    },
    deleteComplianceSubcategory (curCompSubcat) {
      if (!confirm('Sure, you want to delete the compliance subcategory "' + curCompSubcat.name + '"?')) {
        return
      }
      this.beingSaved = true

      this.axios.post(config.API_URL + '/compliance-subcategory/delete', { id: curCompSubcat.id })
      .then(response => {
        const idx = this.complianceSubcatList.findIndex(rec => rec.id === curCompSubcat.id)
        if (idx > -1) {
          this.complianceSubcatList.splice(idx, 1)
        }
        this.msg('Compliance subcategory deleted successfully', 1)
        this.beingSaved = false
        this.showComplianceSubcat = false
      })
      .catch(err => {
        this.msg(err.response && err.response.data ? err.response.data : 'Error deleting compliance subcategory', 0)
        this.beingSaved = false
      })
    },
    prepareCreateCompliance () {
      // Reset form with proper defaults
      this.lCompliance = {
        action: 'Create',
        compliance_id: null,
        name: '',
        compliance_type_id: null,
        compliance_category_id: null,
        compliance_subcategory_id: null,
        remarks: '',
        frequency: '',
        valid_from: '',
        valid_to: '',
        show_dashboard: false,
        notify_before_days: 0,
        cost: null,
        files: []
      }

      // Reset the form validation if it exists
      if (this.$refs.complianceForm) {
        this.$nextTick(() => {
          this.$refs.complianceForm.resetValidation()
        })
      }

      this.showCompliance = true
    },
    prepareEditCompliance (item) {
      const formatDateForPicker = (isoStr) => {
        if (!isoStr) return ''
        const d = new Date(isoStr)
        const month = (d.getMonth() + 1).toString().padStart(2, '0')
        const day = d.getDate().toString().padStart(2, '0')
        return `${d.getFullYear()}-${month}-${day}`
      }

      // Ensure compliance_type_id is properly set
      const typeId = item.compliance_type_id || item.type_id

      // Log for debugging
      console.log('Editing compliance:', item)
      console.log('Extracted compliance_type_id:', typeId)

      this.lCompliance = {
        action: 'Update',
        id: item.id,
        name: item.compliance_name || item.name,
        compliance_type_id: typeId,
        compliance_category_id: item.category_id || item.compliance_category_id,
        compliance_subcategory_id: item.subcategory_id || item.compliance_subcategory_id,
        remarks: item.remarks || '',
        frequency: item.frequency || '',
        valid_from: formatDateForPicker(item.valid_from),
        valid_to: formatDateForPicker(item.valid_to),
        show_dashboard: item.show_dashboard || false,
        notify_before_days: item.notify_before_days || 0,
        cost: item.cost || null,
        files: []
      }

      // Load existing attachments for update mode
      this.loadComplianceAttachment(this.lCompliance)

      // Verify the compliance_type_id is set
      if (!this.lCompliance.compliance_type_id) {
        console.warn('Warning: compliance_type_id is null in edit mode. Item data:', item)
      }

      this.showCompliance = true
    },
    onComplianceCategoryChange () {
      // Reset subcategory when category changes
      this.lCompliance.compliance_subcategory_id = null
    },
    pickComplianceFile () {
      this.$refs.complianceFileInput.click()
    },
    loadComplianceFilesFromBrowser (event) {
      const files = event.target.files

      // Ensure files array is initialized
      if (!this.lCompliance.files) {
        this.$set(this.lCompliance, 'files', [])
      }

      Array.from(files).forEach((file) => {
        // Check file size (20MB limit)
        if (file.size > 20 * 1024 * 1024) {
          this.msg(`File ${file.name} exceeds 20MB limit`, 0)
          return
        }

        const fileReader = new FileReader()
        fileReader.onload = e => {
          this.lCompliance.files.push({
            file_url: e.target.result.split(',')[1], // Base64 data
            file_name: file.name,
            is_selected: true,
            is_changed: true // New file
          })
        }
        fileReader.readAsDataURL(file)
      })

      // Reset input
      if (this.$refs.complianceFileInput) {
        this.$refs.complianceFileInput.value = ''
      }
    },
    loadComplianceAttachment (curCompliance) {
      var qry = {
        params: {
          compliance_id: curCompliance.id || curCompliance.compliance_id
        }
      }

      this.axios.get(config.API_URL + '/getAttachmentsByComplianceId', qry)
        .then(response => {
          console.log('Compliance attachments loaded:', response.data)
          const files = []
          if (response.data && response.data.length > 0) {
            response.data.forEach((rec) => {
              files.push({
                id: rec.id,
                file_url: rec.file_url,
                file_name: rec.file_name || rec.file_url.split('/').pop(),
                is_selected: true,
                is_changed: false
              })
            })
          }
          // Use Vue.set to ensure reactivity
          this.$set(curCompliance, 'files', files)
          console.log('Files set to lCompliance:', curCompliance.files)
        })
        .catch(err => {
          console.error('Error loading compliance attachments:', err)
          this.$set(curCompliance, 'files', [])
        })
    },
    removeComplianceFile (file) {
      // Mark file as not selected instead of removing from array
      const index = this.lCompliance.files.indexOf(file)
      if (index !== -1) {
        this.$set(this.lCompliance.files[index], 'is_selected', false)
        // If it's an existing file (not newly uploaded), mark it for deletion
        if (!this.lCompliance.files[index].is_changed) {
          this.$set(this.lCompliance.files[index], 'to_delete', true)
        }
      }
    },
    downloadComplianceFile (file) {
      if (file.file_url) {
        const fileUrl = file.file_url.startsWith('http')
          ? file.file_url
          : config.FM_SPACES_BASE_URL + file.file_url

        // Open in new tab for download
        window.open(fileUrl, '_blank')
      }
    },
    getFileIcon (fileName) {
      if (!fileName) return 'insert_drive_file'

      const ext = fileName.split('.').pop().toLowerCase()
      const iconMap = {
        'pdf': 'picture_as_pdf',
        'doc': 'description',
        'docx': 'description',
        'xls': 'table_chart',
        'xlsx': 'table_chart',
        'png': 'image',
        'jpg': 'image',
        'jpeg': 'image',
        'gif': 'image'
      }
      return iconMap[ext] || 'insert_drive_file'
    },
    saveCompliance (action) {
      if (!this.$refs.complianceForm.validate()) {
        return
      }

      // Additional validation with detailed logging for debugging
      if (!this.lCompliance.name || this.lCompliance.name.trim() === '') {
        this.msg('Please enter compliance name', 0)
        return
      }

      // Critical validation for compliance_type_id
      if (!this.lCompliance.compliance_type_id || this.lCompliance.compliance_type_id === null) {
        console.error('Compliance Type ID is null or undefined:', this.lCompliance.compliance_type_id)
        console.log('Available compliance types:', this.complianceTypeList)
        this.msg('Please select compliance type', 0)
        return
      }

      if (!this.lCompliance.compliance_category_id) {
        this.msg('Please select compliance category', 0)
        return
      }
      if (!this.lCompliance.compliance_subcategory_id) {
        this.msg('Please select compliance subcategory', 0)
        return
      }
      if (!this.lCompliance.frequency) {
        this.msg('Please select frequency', 0)
        return
      }
      if (!this.lCompliance.valid_from) {
        this.msg('Please select valid from date', 0)
        return
      }
      if (!this.lCompliance.valid_to) {
        this.msg('Please select valid to date', 0)
        return
      }

      // Final sanity check before submitting
      const typeId = parseInt(this.lCompliance.compliance_type_id)
      if (isNaN(typeId) || typeId <= 0) {
        console.error('Invalid compliance_type_id after parsing:', typeId, 'Original:', this.lCompliance.compliance_type_id)
        this.msg('Invalid compliance type selected. Please try again.', 0)
        return
      }

      this.beingSaved = true

      const endpoint = action === 'Create' ? '/compliance/create' : '/compliance/update'

      const formatDateForMySQL = (dateStr) => {
        if (!dateStr) return null
        const d = new Date(dateStr)
        const month = (d.getMonth() + 1).toString().padStart(2, '0')
        const day = d.getDate().toString().padStart(2, '0')
        return `${d.getFullYear()}-${month}-${day}`
      }

      const payload = {
        compliance_name: this.lCompliance.name,
        compliance_type_id: parseInt(this.lCompliance.compliance_type_id),
        category_id: parseInt(this.lCompliance.compliance_category_id),
        subcategory_id: parseInt(this.lCompliance.compliance_subcategory_id),
        community_id: parseInt(config.COMM_ID),
        status: 'Active',
        frequency: this.lCompliance.frequency,
        valid_from: formatDateForMySQL(this.lCompliance.valid_from),
        valid_to: formatDateForMySQL(this.lCompliance.valid_to),
        remarks: this.lCompliance.remarks || '',
        cost: this.lCompliance.cost ? parseFloat(this.lCompliance.cost) : null,
        show_dashboard: this.lCompliance.show_dashboard ? 1 : 0,
        notify_before_days: this.lCompliance.notify_before_days,
        created_by: parseInt(config.USER_ID),
        updated_by: parseInt(config.USER_ID)
      }

      if (action === 'Update') {
        payload.id = parseInt(this.lCompliance.id)
      }

      // Include files array if there are any files
      if (this.lCompliance.files && this.lCompliance.files.length > 0) {
        // Include all files (selected and marked for deletion)
        payload.files = this.lCompliance.files
      }

      this.axios.post(config.API_URL + endpoint, payload)
        .then(response => {
          if (action === 'Create') {
            this.msg('Compliance created successfully', 1)
          } else {
            this.msg('Compliance updated successfully', 1)
          }
          this.loadCompliance()
          this.beingSaved = false
          this.showCompliance = false
        })
        .catch(err => {
          this.msg(err.response && err.response.data ? err.response.data : 'Error saving compliance', 0)
          this.beingSaved = false
        })
    },
    deleteCompliance (item) {
      if (!confirm('Are you sure you want to delete this compliance?')) {
        return
      }

      this.beingSaved = true

      if (!item.id) {
        this.msg('Invalid compliance selected', 0)
        return
      }
      const payload = {
        id: item.id
      }

      this.axios.post(config.API_URL + '/compliance/delete', payload)
      .then(response => {
        this.msg('Compliance deleted successfully', 1)
        this.loadCompliance()
        this.beingSaved = false
        this.showCompliance = false
      })
      .catch(err => {
        this.msg(err.response && err.response.data ? err.response.data : 'Error deleting compliance', 0)
        this.beingSaved = false
      })
    },
    openFile (file) {
      if (!file) {
        return
      }

      // If the file has a URL, open it directly
      if (file.file_url) {
        // Check if it's a base64 encoded file
        if (file.file_url.startsWith('data:') || !file.file_url.startsWith('http')) {
          // For base64 or relative paths, create a blob and download
          const link = document.createElement('a')

          // If it's already a data URL
          if (file.file_url.startsWith('data:')) {
            link.href = file.file_url
          } else {
            // Assume it's base64 without the data URL prefix
            const mimeType = this.getMimeType(file.file_name)
            link.href = `data:${mimeType};base64,${file.file_url}`
          }

          link.download = file.file_name || 'attachment'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        } else {
          // For absolute URLs, open in new tab
          window.open(file.file_url, '_blank')
        }
      }
    },
    getMimeType (filename) {
      if (!filename) return 'application/octet-stream'

      const ext = filename.split('.').pop().toLowerCase()
      const mimeTypes = {
        'pdf': 'application/pdf',
        'doc': 'application/msword',
        'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'xls': 'application/vnd.ms-excel',
        'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'png': 'image/png',
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'gif': 'image/gif',
        'txt': 'text/plain',
        'csv': 'text/csv'
      }

      return mimeTypes[ext] || 'application/octet-stream'
    }
  }
}
</script>



// WEBPACK FOOTER //
// Facconfig.vue?af889f2a